@import "../../themes/stories.globals";

:host {
  display: inline;
}

svg {
  width: 14px;
  height: 14px;
}

path {
  fill: currentColor;
}
